<template>
  <div class="step_inner">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-result icon="success"  subTitle="简历完善成功，可以设置对外展示">
            <template slot="extra">
              <el-button @click="next">查看简历</el-button>
              <el-button type="primary" @click="next">完成</el-button>

            </template>
          </el-result>
        </el-col> 

      </el-row>
     
  </div>
</template>

<script>

export default {


  data () {
    return {

    }
  },

  mounted () {
  },
  methods:{
    next(){
      this.$router.push({ name: "member-resume" });
    },


    
  }
}
</script>


<style lang="scss" scoped>
.step_inner {
  h2 {
    margin: 0;
    font-size: 19px;
    line-height: 50px;
  }
  .el-col {
    min-height: 51px;
  }
}


.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>